import axios from "axios";

export default {
  methods: {
    /**
     * Recupera os dados gerais do prestador
     * @param {Number} id
     * @return {
     * {
     *    "atualizacao": "string",
     *    "cbo": 0,
     *    "cdConselho": "string",
     *    "classificacaoEstabelecimento": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "cnes": "string",
     *    "cnpjFilial": true,
     *    "codigo": 0,
     *    "contratualizacao": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "cpfCnpj": "string",
     *    "disponibilidade": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "dtExclusao": "string",
     *    "dtInclusao": "string",
     *    "dtInicioContratualizacao": "string",
     *    "dtInicioServico": "string",
     *    "idSuspTempHosp": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "motivoSuspHosp": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "dtIniSuspHosp": "string",
     *    "dtNascimento": "string",
     *    "genero": "string",
     *    "inscricaoEst": "string",
     *    "nome": "string",
     *    "nomeFantasia": "string",
     *    "perfilAssistencial": 0,
     *    "produto": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "rede": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "tipo": "MEDICO",
     *    "titulacao1": 0,
     *    "titulacao2": 0,
     *    "unimedPrestadora": 0,
     *    "nomeUnimedPrestadora":"",
     *    "vinculo": "COOPERADO",
     *    "altoCusto": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "atendeIntercambio": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "atendeIntercambioAnterior": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "atendeProntoSocorro": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "enviarWsdTiss": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "envioCadu": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "exibirNoGuiaMedico": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "prestadorAtivo": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "tabelaPropria": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "telesSaude": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    }
     *  }
     * }
     */
    getDadosGeraisPrestador(id) {
      return axios.get(
        this.CriarUrl({
          resource: `prestadores/dadosGerais/${id}`
        })
      );
    },
    /**
     * Recupera as informações de qualificação
     * @param {Number} id
     * @return {
     * {
     *    "certificacaoIso9001": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "doutoradoOuPosDoutorado": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "novisa": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "posGraduacao": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "qualiss": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "redeAcidenteDeTrabalho": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "residenciaEmSaude": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "tituloDeEspecialista": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    }
     *  }
     * }
     */
    getQualificacao(id) {
      return axios.get(
        this.CriarUrl({
          resource: `prestadores/qualificacao/${id}`
        })
      );
    },
    /**
     * Recupera a informações sobre direção e liderança
     * @param {Number} id
     * @return {
     * {
     *    "conselho": "string",
     *    "nomeDiretorTecnico": "string",
     *    "registroConselho": "string",
     *    "ufConselho": "string"
     *  }
     * }
     */
    getDirecaoELideranca(id) {
      return axios.get(
        this.CriarUrl({
          resource: `prestadores/direcaoELideranca/${id}`
        })
      );
    },
    /**
     * Recupera informações do endereço principal
     * @param {Number} id
     * @return {
     * {
     *    "bairro": "string",
     *    "cep": "string",
     *    "cidade": "string",
     *    "codigoMunicipal": "string",
     *    "codigoReferencia": "string",
     *    "latitude": "string",
     *    "logradouro": "string",
     *    "longitude": "string",
     *    "numero": "string",
     *    "uf": "string"
     *  }
     * }
     */
    getEndereco(id) {
      return axios.get(
        this.CriarUrl({
          resource: `prestadores/endereco/${id}`
        })
      );
    },
    /**
     * Recupera os dados sobre especialidade de um prestador
     * @param {Number} id
     * @return {
     *   {
     *    "areaAtuacaoOutros": {
     *      "exibirGuiaMedico": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "nome": "string",
     *      "possuiRqe": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "possuiResidencia": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "registroDois": 0,
     *      "registroUm": 0
     *    },
     *    "areaAtuacaoPrincipal": {
     *      "exibirGuiaMedico": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "nome": "string",
     *      "possuiRqe": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "possuiResidencia": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "registroDois": 0,
     *      "registroUm": 0
     *    },
     *    "especialidadeAtende": {
     *      "chave": "PROCESSANDO",
     *      "descricao": "string"
     *    },
     *    "especialidadeOutros": {
     *      "exibirGuiaMedico": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "nome": "string",
     *      "possuiRqe": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "possuiResidencia": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "registroDois": 0,
     *      "registroUm": 0
     *    },
     *    "especialidadePrincipal": {
     *      "exibirGuiaMedico": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "nome": "string",
     *      "possuiRqe": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "possuiResidencia": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "registroDois": 0,
     *      "registroUm": 0
     *    }
     *  }
     * }
     */
    getEspecialidades(id) {
      return axios.get(
        this.CriarUrl({
          resource: `especialidade/${id}`
        })
      );
    },
    /**
     * Recupera os dados do contato principal
     * @param {Number} id
     * @return {
     *   {
     *      "email": "string",
     *      "emailSecundario": "string",
     *      "fax": "string",
     *      "faxDdd": "string",
     *      "site": "string",
     *      "telefone": "string",
     *      "telefoneDdd": "string",
     *      "telefoneSecundario": "string",
     *      "telefoneSecundarioDdd": "string",
     *      "whatsapp": "string",
     *      "whatsappDdd": "string"
     *    }
     * }
     */
    getContatoPrincipal(id) {
      return axios.get(
        this.CriarUrl({
          resource: `contato/principal/${id}`
        })
      );
    },
    /**
     * Recupera os dados dos leitos de forma genérica
     * @param {Number} id
     * @return {
     * [
     *    {
     *      "nome": "string",
     *      "quantidade": 0
     *    }
     *  ]
     * }
     */
    getLeitos(id) {
      return axios.get(
        this.CriarUrl({
          resource: `leito/${id}`
        })
      );
    },
    /**
     * Recupera todos os grupos de serviço
     * @param {Number} id
     * @return {
     *   [
     *      {
     *        "codigo": 0,
     *        "nome": "string"
     *      }
     *    ]
     * }
     */
    getGrupoServico(id) {
      return axios.get(
        this.CriarUrl({
          resource: `grupoServico/${id}`
        })
      );
    },
    /**
     * Recupera todos as redes referenciadas
     * @param {Number} id
     * @return {
     *   [
     *      {
     *        "codigo": "string",
     *        "nome": "string"
     *      }
     *    ]
     * }
     */
    getRedeReferenciada(id) {
      return axios.get(
        this.CriarUrl({
          resource: `redeReferenciada/${id}`
        })
      );
    },

    getMotivoExclusao(id) {
      return axios.get(
        this.CriarUrl({ resource: `prestadores/exclusao/${id}` })
      );
    }
  }
};
